import React from "react";
import {reduxWrapper} from "./globalState";
import {isLive, mapArray} from "./lib/tools";
import wasm from "source-map/lib/mappings.wasm";
import {Image} from "./components/common/common";

if (window.sourceMap) window.sourceMap.SourceMapConsumer.initialize({"lib/mappings.wasm": wasm});

class ReporterRender extends React.Component {
	state = {
		hasError: false
	};
	
	timeout = null;
	error = false;
	disabled = true;
	
	componentDidCatch(error, info) {
		console.log(error);
		if (!isLive() && this.disabled) return;
		this.setState({hasError: true});
		
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			window.location.pathname === "/" ?
				window.location.reload() :
				this.props.history.push("/");
			this.setState({hasError: false});
		}, 2000);
		
		mapTrace(error).then(trace => {
			const errorPayload = {
				path: window.location.pathname,
				timeSpent: new Date() - this.props.startTime,
				componentStack: mapArray(info.componentStack.split("\n"), x => x.length > 0 ? x.trim() : null),
				errorType: error.type || error.name,
				message: error.message,
				stack: trace
			};
			
			if (isLive()) {
				this.props.apiCall("POST", "/report/error", null, errorPayload);
			} else {
				console.log(errorPayload);
			}
		});
	}
	
	render() {
		if (this.state.hasError || this.error) {
			return (
				<div id="error404" className="maxWidth"> 
					<Image src="https://media.festen.dk/404.png"/>
					<p>
						Der er sket en fejl. Vi sender dig tilbage til forsiden og sender vores bedste tekniskere på opgaven.
					</p>
				</div>
			)
		}
		return this.props.children;
	}
}

let consumer = null;

async function mapTrace(error) {
	const trace = error.stack.split("\n").slice(error.custom ? 3 : 1).map(x => x.trim());
	let fileName = null;
	const lines = mapArray(trace, x => {
		const match = x.match(/\((.+):(\d+):(\d+)\)/);
		if (!match) return null;
		const [file, line, column] = match;
		if (!fileName) fileName = file + ".map";
		return {line: parseInt(line, 10), column: parseInt(column, 10)};
	});
	
	if (!consumer) {
		const data = await fetch(fileName);
		const json = await data.json();
		consumer = await new window.sourceMap.SourceMapConsumer(json);
	}
	
	console.log(trace);
	console.log(lines);
	
	const newTrace = {};
	let prev = null;
	consumer.eachMapping(m => {
		const index = lines.findIndex(x => m.generatedLine <= x.line && (!isLive() || x.column < m.generatedColumn));
		if (prev && index !== -1) {
			console.log(prev);
			newTrace[index] = {line: prev.originalLine, file: prev.source};
			lines.splice(index, 1);
		}
		prev = m;
	});
	
	return newTrace;
}

export const Reporter = reduxWrapper("getApiCall")(ReporterRender);


// WEBPACK FOOTER //
// ./src/errorHandling.js